import { render, staticRenderFns } from "./ContainerItem.vue?vue&type=template&id=494e1337&lang=pug&"
import script from "./ContainerItem.vue?vue&type=script&lang=js&"
export * from "./ContainerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports